export type CustomDeadlineModel = {
  cache_key: number,
  alert_emails: string[],
  dates: {
    deadline?: {
      date?: string,
      time?: string,
    },
  },
  deadline_date: string,
  deadline_type: string,
  deadline_time: string,
  description: string,
  enabled_days: number[],
  id: number,
  occurs_daily: boolean,
  owner_id: number,
  owner_type: string,
  send_alert: boolean,
  title: string,
}

export type CustomDeadlineRequestOptions = {}

const state = {
  alert_emails: [],
  deadline_date: '',
  deadline_time: '',
  deadline_type: 'once',
  description: '',
  enabled_days: [],
  id: null,
  occurs_daily: false,
  owner_id: undefined,
  owner_type: '',
  title: '',
}

export const requiredFields = [
  { key: 'deadline_time' },
  { key: 'description' },
  { key: 'title' },
]

export default state
